export const errorRoutes = [
  {
    path: '/error/404',
    component: () => import('@/views/modules/error/404/404'),
    meta: { name: '404', keepAlive: true }
  },
  {
    path: '/error/401',
    component: () => import('@/views/modules/error/401/401'),
    meta: { name: '401', keepAlive: true }
  }
];

